import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from 'react-router-dom';
import { GeneralInfoProvider } from './contexts/GeneralInfoContext';
import { NotificationProvider } from './contexts/NotificationContext.js';
import { ConfirmProvider } from './contexts/ConfirmContext.js';
import Notification from './components/Notification.js';
import { FaFileAlt, FaBalanceScale, FaSun, FaCalendarAlt, FaHourglassEnd, FaClipboardList, FaBook, FaCog, FaArrowRight, FaEnvelope, FaStamp } from 'react-icons/fa';

// Sayfaları import et
import Summaries from './components/Summaries.js';
import Calculation from './components/Calculation.js';
// import ShowReport from './components/ShowReport';
import Settings from './pages/Settings.js';
import KayitliTakrirler from './pages/KayitliTakrirler.js';
import SunTimes from './pages/SunTimes.js';
import KararSablonlari from './pages/KararSablonlari.js';
import DateDifference from './pages/DateDifference.js';
import ZamanAsimi from './pages/ZamanAsimi.js';
import KanunYoluSuresi from './pages/KanunYoluSuresi.js';

function App() {
  return (
    <Router>
      <NotificationProvider>
        <GeneralInfoProvider>
          <ConfirmProvider>
            <AppContent />
          </ConfirmProvider>
        </GeneralInfoProvider>
      </NotificationProvider>
    </Router>
  );
}

function AppContent() {
  const [reportData, setReportData] = React.useState({});
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  const updateReportData = (section, data) => {
    setReportData(prevData => ({
      ...prevData,
      [section]: data
    }));
  };

  useEffect(() => {
    const selectedTakrir = localStorage.getItem('selectedTakrir');
    if (selectedTakrir) {
      updateReportData('all', JSON.parse(selectedTakrir));
      localStorage.removeItem('selectedTakrir');
    }
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  return (
    <div className={`min-h-screen flex flex-col ${isHome ? 'bg-slate-950' : 'app-canvas'}`}>
      <Notification />
      <nav className="app-nav sticky top-0 z-50">
        <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <Link to="/" className="flex-shrink-0 flex items-center gap-2.5">
                <span className="inline-block h-2 w-2 rounded-full bg-amber-400 shadow-[0_0_12px_rgba(251,191,36,0.7)]" />
                <span className="font-display text-xl font-semibold tracking-wide text-white">Mustafa EKİM</span>
              </Link>
            </div>
            <div className="hidden sm:ml-6 sm:flex sm:items-center">
              {/* <NavLink to="/summaries" dark={isHome}>Takrir Raporu</NavLink> */}
              <NavLink to="/ceza-hesaplama" dark={isHome}>Ceza Hesaplama</NavLink>
              <NavLink to="/gunes-saatleri" dark={isHome}>Güneş Saatleri</NavLink>
              <NavLink to="/tarih-farki" dark={isHome}>Tarih ve Yaş Hesaplama</NavLink>
              <NavLink to="/zaman-asimi" dark={isHome}>Dava Zamanaşımı</NavLink>
              <NavLink to="/kanun-yolu-suresi" dark={isHome}>Kanun Yolu Süresi</NavLink>
              {/* <NavLink to="/karar-sablonlari" dark={isHome}>Karar Şablonları</NavLink> */}
              {/* <NavLink to="/kayitli-takrirler" dark={isHome}>Kayıtlı Takrirler</NavLink> */}
              {/* <NavLink to="/ayarlar" dark={isHome}>Ayarlar</NavLink> */}
            </div>
            <div className="flex items-center sm:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="inline-flex items-center justify-center p-2 rounded-md text-slate-300 hover:text-white hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-amber-400"
              >
                <span className="sr-only">Ana menüyü aç</span>
                <svg className={`${isMenuOpen ? 'hidden' : 'block'} h-6 w-6`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
                <svg className={`${isMenuOpen ? 'block' : 'hidden'} h-6 w-6`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>
        {/* Mobil menü */}
        <div className={`sm:hidden ${isMenuOpen ? 'block' : 'hidden'} bg-slate-950/95 backdrop-blur-md border-t border-white/10`}>
          <div className="pt-2 pb-3 space-y-1">
            {/* <MobileNavLink to="/summaries" dark={isHome}>Takrir Raporu</MobileNavLink> */}
            <MobileNavLink to="/ceza-hesaplama" dark={isHome}>Ceza Hesaplama</MobileNavLink>
            <MobileNavLink to="/gunes-saatleri" dark={isHome}>Güneş Saatleri</MobileNavLink>
            <MobileNavLink to="/tarih-farki" dark={isHome}>Tarih ve Yaş Hesaplama</MobileNavLink>
            <MobileNavLink to="/zaman-asimi" dark={isHome}>Dava Zamanaşımı</MobileNavLink>
            <MobileNavLink to="/kanun-yolu-suresi" dark={isHome}>Kanun Yolu Süresi</MobileNavLink>
            {/* <MobileNavLink to="/karar-sablonlari" dark={isHome}>Karar Şablonları</MobileNavLink> */}
            {/* <MobileNavLink to="/kayitli-takrirler" dark={isHome}>Kayıtlı Takrirler</MobileNavLink> */}
            {/* <MobileNavLink to="/ayarlar" dark={isHome}>Ayarlar</MobileNavLink> */}
          </div>
        </div>
      </nav>

      <main className={`flex-grow w-full mx-auto ${isHome ? '' : 'px-4 sm:px-6 lg:px-8 py-10'}`}>
        <Routes>
          <Route path="/ceza-hesaplama" element={<Calculation onChange={(data) => updateReportData('calculation', data)} data={reportData.calculation} />} />
          <Route path="/" element={<HomePage />} />
          <Route path="/kayitli-takrirler" element={<KayitliTakrirler />} />
          <Route path="/gunes-saatleri" element={<SunTimes />} />
          <Route path="/karar-sablonlari" element={<KararSablonlari />} />
          <Route path="/ayarlar" element={<Settings onChange={(data) => updateReportData('settings', data)} data={reportData.settings} />} />
          <Route path="/tarih-farki" element={<DateDifference />} />
          <Route path="/zaman-asimi" element={<ZamanAsimi />} />
          <Route path="/kanun-yolu-suresi" element={<KanunYoluSuresi />} />
          <Route path="/summaries" element={<Summaries />} />
        </Routes>
      </main>

      {/* Global iletişim footer'ı — temaya uyumlu, sade */}
      <footer
        className={`border-t px-4 py-4 text-center text-xs ${
          isHome ? 'border-white/10 text-slate-500' : 'border-slate-200 text-slate-400'
        }`}
      >
        <span>Bilgi ve görüşleriniz için </span>
        <a
          href="mailto:mstfkm@gmail.com?subject=Bilgi%20ve%20G%C3%B6r%C3%BC%C5%9F"
          className={`inline-flex items-center gap-1 font-medium transition-colors ${
            isHome ? 'text-amber-300/90 hover:text-amber-200' : 'text-indigo-600 hover:text-indigo-700'
          }`}
        >
          <FaEnvelope className="h-3 w-3" />
          mstfkm@gmail.com
        </a>
      </footer>
    </div>
  );
}

function NavLink({ to, children }) {
  const location = useLocation();
  const isActive = location.pathname === to;

  const activeClass = 'bg-amber-400 text-slate-900 shadow-sm';
  const inactiveClass = 'text-slate-300 hover:bg-white/10 hover:text-white';

  return (
    <Link
      to={to}
      className={`px-3 py-2 rounded-md text-sm font-medium ${
        isActive ? activeClass : inactiveClass
      } transition duration-150 ease-in-out`}
    >
      {children}
    </Link>
  );
}

function MobileNavLink({ to, children }) {
  const location = useLocation();
  const isActive = location.pathname === to;

  const activeClass = 'bg-amber-400 text-slate-900';
  const inactiveClass = 'text-slate-300 hover:bg-white/10 hover:text-white';

  return (
    <Link
      to={to}
      className={`block px-3 py-2 rounded-md text-base font-medium ${
        isActive ? activeClass : inactiveClass
      } transition duration-150 ease-in-out`}
    >
      {children}
    </Link>
  );
}

function HomePage() {
  const menuItems = [
    /* {
      title: 'Takrir Raporu',
      Icon: FaFileAlt,
      path: '/summaries',
      description: 'Takrir raporu oluşturun ve düzenleyin'
    }, */
    {
      title: 'Ceza Hesaplama',
      Icon: FaBalanceScale,
      path: '/ceza-hesaplama',
      description: 'Ceza hesaplamaları yapın'
    },
    {
      title: 'Güneş Saatleri',
      Icon: FaSun,
      path: '/gunes-saatleri',
      description: 'Güneş doğuş ve batış saatlerini görüntüleyin'
    },
    {
      title: 'Tarih ve Yaş Hesaplama',
      Icon: FaCalendarAlt,
      path: '/tarih-farki',
      description: 'Tarih farkı ve yaş hesaplamaları yapın'
    },
    {
      title: 'Dava Zamanaşımı',
      Icon: FaHourglassEnd,
      path: '/zaman-asimi',
      description: 'TCK 66–67 dava zamanaşımı süresini hesaplayın',
      deneysel: true
    },
    {
      title: 'Kanun Yolu Süresi Hesaplama',
      Icon: FaStamp,
      path: '/kanun-yolu-suresi',
      description: 'Tebliğ tarihinden kanun yolu son günü ve kesinleşme tarihini hesaplayın'
    }
    /* {
      title: 'Karar Şablonları',
      Icon: FaClipboardList,
      path: '/karar-sablonlari',
      description: 'Hazır karar şablonlarına erişin'
    },
    {
      title: 'Kayıtlı Takrirler',
      Icon: FaBook,
      path: '/kayitli-takrirler',
      description: 'Kayıtlı takrirlerinizi görüntüleyin'
    },
    {
      title: 'Ayarlar',
      Icon: FaCog,
      path: '/ayarlar',
      description: 'Uygulama ayarlarını düzenleyin'
    } */
  ];

  const bugun = new Date().toLocaleDateString('tr-TR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

  return (
    <div className="relative min-h-[calc(100vh-4rem)] overflow-hidden bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950">
      {/* Dekoratif ışık huzmeleri */}
      <div className="pointer-events-none absolute -top-32 -left-32 h-96 w-96 rounded-full bg-amber-500/10 blur-3xl" />
      <div className="pointer-events-none absolute top-1/4 -right-40 h-[28rem] w-[28rem] rounded-full bg-indigo-600/10 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 left-1/3 h-80 w-80 rounded-full bg-amber-400/5 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8 lg:py-20">
        {/* Karşılama */}
        <header className="mb-12 animate-fade-in-up">
          <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <p className="text-xs font-medium uppercase tracking-[0.25em] text-amber-300/80">
                Hoş Geldiniz
              </p>
              <h1 className="mt-3 font-display text-4xl font-semibold tracking-tight text-white sm:text-5xl lg:text-6xl">
                Yargı<span className="text-amber-300">t</span><span className="mt-3 font-display text-4xl font-semibold tracking-tight text-white sm:text-5xl lg:text-6xl">Ai</span> <span className="text-amber-300">Hukuk Araçları Alanı</span>
              </h1>
              <p className="mt-3 max-w-xl text-sm text-slate-400 sm:text-base">
                Başlamak için aşağıdan bir araç seçin.
              </p>
            </div>
            <div className="flex items-center gap-3 self-start rounded-full border border-white/10 bg-white/5 px-4 py-2 backdrop-blur-sm sm:self-auto">
              <FaCalendarAlt className="h-4 w-4 text-amber-300/80" />
              <span className="text-sm text-slate-300">{bugun}</span>
            </div>
          </div>
          <div className="mt-8 h-px w-full bg-gradient-to-r from-amber-300/40 via-amber-300/10 to-transparent" />
        </header>

        {/* Araç kartları */}
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {menuItems.map((item, index) => {
            const IconComponent = item.Icon;
            return (
              <Link
                key={index}
                to={item.path}
                style={{ animationDelay: `${index * 60}ms` }}
                className="group relative block animate-fade-in-up"
              >
                <div className="relative flex h-full min-h-[208px] flex-col overflow-hidden rounded-2xl border border-white/10 bg-white/[0.04] p-6 backdrop-blur-sm transition-all duration-300 ease-out hover:-translate-y-1 hover:border-amber-300/40 hover:bg-white/[0.07] hover:shadow-[0_24px_48px_-18px_rgba(251,191,36,0.35)]">
                  {/* Üst parıltı çizgisi */}
                  <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-amber-300/60 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />

                  {item.deneysel ? (
                    <span className="absolute right-4 top-4 rounded-full border border-amber-300/40 bg-amber-400/10 px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-amber-300">
                      Deneysel
                    </span>
                  ) : null}

                  <div className="inline-flex w-fit rounded-xl bg-amber-400/10 p-3 ring-1 ring-amber-300/20 transition-all duration-300 group-hover:bg-amber-400/20 group-hover:ring-amber-300/40">
                    <IconComponent className="h-6 w-6 text-amber-300 transition-transform duration-300 group-hover:scale-110" />
                  </div>

                  <h2 className="mt-5 text-lg font-semibold text-white">{item.title}</h2>
                  <p className="mt-2 text-sm leading-relaxed text-slate-400">{item.description}</p>

                  <div className="mt-auto flex items-center gap-2 pt-5 text-sm font-medium text-amber-300/0 transition-colors duration-300 group-hover:text-amber-300">
                    <span>Aç</span>
                    <FaArrowRight className="h-3 w-3 -translate-x-1 transition-transform duration-300 group-hover:translate-x-0" />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default App;
